/**
 * Shared look for a clickable panel row: the mapping panel's role rows, the
 * layer panel's layer rows, and the issues panel's issue rows all render the
 * same rest / hover / selected highlight, and this is the one place that
 * combination lives.
 *
 * Spread the result onto whichever element in a row is the actual button —
 * the row itself for `DxfMappingRow` and the issues panel's row, or the
 * inner name+badge button for `DxfLayerRow` (its checkbox sits outside the
 * selectable button and isn't part of this). Business logic — the click and
 * hover handlers themselves, and what "selected"/"selectable" mean for that
 * row — stays in each panel; this only answers how the row should look for
 * a given `(isSelected, isSelectable)` pair.
 */
export const selectablePanelRowStyles = (
  isSelected: boolean,
  isSelectable: boolean,
) => ({
  'aria-pressed': isSelected,
  cursor: isSelectable ? ('pointer' as const) : ('default' as const),
  bg: isSelected ? 'interaction.surfaceActive' : 'page.surface',
  _hover:
    isSelectable && !isSelected
      ? { bg: 'interaction.surfaceHover', color: 'interaction.main' }
      : undefined,
  color: isSelected ? 'interaction.main' : 'feature.secondary',
  transitionProperty: 'color, background-color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease-in-out',
});
